export default __webpack_public_path__ + "static/media/result_3.23dce068.jpg";